import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 乌克兰语
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Всі права захищені',
    },
    auth: {
        login: 'Увійти',
        username: 'Ім\'я користувача',
        username_placeholder: 'Введіть ім\'я користувача',
        password: 'Пароль',
        password_placeholder: 'Введіть пароль',
        code: 'Код підтвердження',
        code_placeholder: 'Введіть код підтвердження',
        logout: 'Вийти',
        logout_success: 'Ви успішно вийшли з системи',
        day: 'день',
        password_expiration: 'Термін дії пароля закінчився – будь ласка, змініть його',
        expire: 'Залишилося часу до закінчення терміну дії пароля',
        conseils:
            'Повинен містити великі літери, малі літери, цифри та спеціальні символи ({msg}). Довжина пароля має бути від 8 до 16 символів.',
        brand_Selection: 'Вибір бренду',
        unread_notices: 'Непрочитані повідомлення',
        new_cases: 'Нові звернення',
        unanswered_cases: 'Невідповіді звернення',
        overdue_cases: 'Прострочені звернення',
    },
    button: {
        query: 'Запит',
        editing_position: 'Редагувати позицію',
        show_theme_editor: 'Показати/сховати редактор теми',
        change_password: 'Змінити пароль',
        old_password: 'Старий пароль',
        new_password: 'Новий пароль',
        confirm_password: 'Підтвердіть пароль',
        button: 'Кнопка',
        about: 'Про нас',
        back: 'Назад',
        go: 'ОК',
        home: 'Головна',
        confirm: 'Підтвердити',
        modify: 'Змінити',
        edit: 'Редагувати',
        new: 'Новий',
        cancel: 'Скасувати',
        close: 'Закрити',
        search: 'Пошук',
        reset: 'Скинути',
        delete: 'Видалити',
        add: 'Додати',
        collapse: 'Згорнути',
        expand: 'Розгорнути',
        download_template: 'Завантажити шаблон',
        batch_import: 'Імпорт партією',
        import: 'Імпортувати',
        export: 'Експортувати',
        export_fail: 'Імпорт не вдався',
        detailed: 'Детальний',
        details: 'Деталі',
        download: 'Завантажити',
        toView: 'Переглянути',
        toViews: 'Переглянути зображення',
        uploadAttachments: 'Завантажити вкладення',
        selectFile: 'Вибрати файл',
        fillingInstructions: 'Інструкції щодо заповнення',
        release: 'Опублікувати',
        release_recall: 'Скасувати публікацію',
        save: 'Зберегти',
        send: 'Надіслати',
        tips: 'Поради',
        send_back: 'Повернути',
        examine: 'Перевірити',
        void: 'Анулювати',
        more: 'Більше',
        refresh: 'Оновити',
        selects: 'Вибрати',
        serial_number: 'Серійний номер',
        upload_progress: 'Прогрес завантаження',
        invalid: 'Недійсний',
        daily_record: 'Щоденний запис',
        operation_type: 'Тип операції',
        field_name: 'Назва поля',
        edit_role: 'Редагувати роль',
        user_role: 'Виберіть роль',
        assignment_role: 'Роль',
        post: 'Посада',
        sending: 'Надсилання...',
        reset_password: 'Скинути пароль',
        display_or_not: 'Показувати чи ні',
        document: 'Документ',
        specificTemplates: 'Спеціальні шаблони',
        transferOrder: 'Передати замовлення',
        forwarding: 'Переслати',
        one_click_notification: 'Сповіщення в один клік',
        english_export: 'Експорт англійською',
        oneclick_download: 'Завантаження в один клік',
        passwordmsga: 'Має містити великі літери, малі літери, цифри та спецсимволи (@\\$!_~\\&*)',
        passwordmsgb: 'Довжина пароля має бути від 8 до 16 символів',
        passwordmsgc: 'Не може збігатися з жодним із останніх шести паролів',
        export_file_list: 'Список експортованих файлів',
        personal_center: 'Особистий кабінет',
        upload_list: 'Список завантажень',
        clear_completed: 'Очистити завершені',
    },
    radio: {
        enabled: 'Увімкнено',
        disabled: 'Вимкнено',
        catalogue: 'Каталог',
        individual: 'Окремо',
        all: 'Усі',
        yes: 'Так',
        no: 'Ні',
    },
    dropdown: {
        close_others: 'Закрити інші',
        close_right: 'Закрити праворуч',
        close_left: 'Закрити ліворуч',
    },
    table: {
        action: 'Дія',
        explain: 'Пояснення',
        fileName: 'Назва файлу',
        size: 'Розмір (МБ)',
        uploader: 'Завантажив(ла)',
        uploadTime: 'Дата завантаження',
        system: 'Система',
        caption: 'Підпис',
        categorization: 'Категоризація',
        link: 'Посилання',
        forwarding_time: 'Дата пересилання',
        forwarder: 'Переслав(ла)',
        send_to: 'Надіслати до',
        mode: 'Режим',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `Сторінка ${named('number')}`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Усього ${named('number')} записів`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) =>
            `Усього ${named('number')} транспортних засобів`,
    },
    confirm: {
        confirm_deletion: 'Підтвердити видалення?',
        confirm_void: 'Підтвердити анулювання?',
        confirm_release: 'Підтвердити публікацію?',
        ack: 'Підтвердити',
        cancel: 'Скасувати',
        non_records: 'Виберіть принаймні один запис',
    },
    request: {
        failed_placeholder: 'Запит не вдався – помилка сервера',
        success_placeholder: 'Запит виконано успішно',
        auth: {
            login_success: 'Успішний вхід',
        },
        error: {
            '404': 'Ресурс не знайдено',
            '403': 'Доступ заборонено',
        },
    },
    page: {
        global: {
            page_search: 'Пошук на сторінці',
        },
        error: {
            not_found: 'Сторінку не знайдено',
            not_found_des: 'Тут нічого немає',
            auth_failed: 'Доступ заборонено',
            auth_failed_des: 'Ця сторінка заборонена',
            file_format_error: 'Недійсний формат файлу!',
            preview_failed: 'Попередній перегляд не вдався! Файл пошкоджено!',
        },
        homepage: {
            homepage: homepage.homepage.ukUA,
        },
        system: {
            menu: system.menu.ukUA,
            dict: system.dict.ukUA,
            dept: system.dept.ukUA,
            role: system.role.ukUA,
            user: system.user.ukUA,
        },
        info: {
            announcement: Info.announcement.announcement.ukUA,
            document: Info.document.document.ukUA,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.ukUA,
                recallActivity: tech.quality.recallActivity.ukUA,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.ukUA,
            },
            management: {
                inquiryOd: tech.management.inquiry.ukUA,
                permission: tech.management.permission.ukUA,
                onSiteSupportHq: tech.management.onSiteSupport.ukUA,
                progHistoryHq: tech.management.progHistory.ukUA,
                salesRecordHq: tech.management.salesRecord.ukUA,
                vehicleInfoHq: tech.management.vehicleInfo.ukUA,
                claimHq: tech.management.claim.ukUA,
                filterHq: tech.management.filter.ukUA,
                newCarlssue: tech.management.newCarIssue.ukUA,
                newCarDefinition: tech.management.newCarDefinition.ukUA,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.ukUA,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.ukUA,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.ukUA,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.ukUA,
        },
        statistics: statistics.inquiryStatistics.ukUA,
        systemClassifyA: statistics.systemClassifyA.ukUA,
        systemClassifyB: statistics.systemClassifyB.ukUA,
        engineerStatistics: statistics.engineerStatistics.ukUA,
        defectivePart: statistics.defectivePart.ukUA,
        replyInquiryStatistics: statistics.replyInquiryStatistics.ukUA,
        passRateStatistics: statistics.passRateStatistics.ukUA,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.ukUA,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.ukUA,
        customsClearance135Rate: statistics.customsClearance135Rate.ukUA,
        accumulatedClosureRate: statistics.accumulatedClosureRate.ukUA,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.ukUA,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.ukUA,
    },
    validation: {
        common: {
            required: 'Це поле обов\'язкове для заповнення',
            numeric: 'Повинно бути цілим числом',
            decimal: 'Повинно бути числом',
            positive_interger: 'Повинно бути додатним цілим числом',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Максимум ${named('number')} цифр`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Дозволено максимум ${named('number')} символів`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Перевищено максимальну довжину (${named('number')} символів)`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Повинно містити принаймні ${named('number')} символів`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Повинно містити рівно ${named('number')} символів`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Не може бути більше за ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Не може бути менше за ${named('number')}`,
            up_to_2_decimal_places: 'Максимум два десяткові знаки',
            retain_up: 'Максимум 10 цифр до коми та 2 після',
            retain_ups: 'Максимум 11 цифр до коми та 4 після',
            input_number: 'Вводьте лише арабські цифри',
            only_number_a: 'Дозволені лише літери або цифри',
            translate: 'Дозволені лише літери',
            positive_integer: 'Заповніть принаймні одне поле',
            at_least_one: 'Заповніть принаймні одне',
        },
        tip: {
            incomplete_information: 'Неповна інформація',
        },
    },
    import: {
        template_file: 'Файл шаблону',
        browse: 'Огляд',
        download_template: 'Завантажити шаблон',
        no_file_selected: 'Файл не вибрано',
        incorrect_file_type: 'Неправильний тип файлу',
        exceed: 'Перевищено ліміт',
        upload_success: 'Завантаження успішне',
        upload_fail: 'Завантаження не вдалося',
        again_upload:
            'Можна завантажувати лише зображення у форматах jpg, png, bmp або gif. Спробуйте ще раз.',
        attachmentUpload: 'Завантажити вкладення',
        otherAttachmentUpload: 'Завантажити інші вкладення',
        supportedFormats: 'Підтримувані формати',
        preview: 'Попередній перегляд',
    },
    export: {
        noDataToExport: 'Немає даних для експорту',
    },
    select: {
        all: 'Усі',
    },
    checkbox: {
        select_all: 'Вибрати все',
    },
    dialog: {
        error_message: 'Повідомлення про помилку',
        one_year: 'Ви можете експортувати дані максимум за один рік одночасно',
    },
    ymd: {
        year: 'рік',
        month: 'місяць',
        day: 'день',
        week: 'тиждень',
        january: 'Січень',
        february: 'Лютий',
        march: 'Березень',
        april: 'Квітень',
        may: 'Травень',
        june: 'Червень',
        july: 'Липень',
        august: 'Серпень',
        september: 'Вересень',
        october: 'Жовтень',
        november: 'Листопад',
        december: 'Грудень',
    },
};
